module.exports = __webpack_public_path__ + "img/icon-success.31c492b9.svg";